import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import UserTrainingPlan from './pages/UserTrainingPlan';
import TrainingLibrary from './pages/TrainingLibrary';
import Calendars from './pages/Calendars';
import PrivateRoute from './components/PrivateRoute';
import MainLayout from './layouts/MainLayout';
import './App.css';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <MainLayout>
                  <Users />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <MainLayout>
                  <Dashboard />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <Navigate to="/" replace />
            }
          />
          <Route
            path="/users/:userId/training"
            element={
              <PrivateRoute>
                <MainLayout>
                  <UserTrainingPlan />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/training-library"
            element={
              <PrivateRoute>
                <MainLayout>
                  <TrainingLibrary />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/calendars"
            element={
              <PrivateRoute>
                <MainLayout>
                  <Calendars />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
